import React from 'react';
import {Grid} from "@mui/material";

function AboutHero() {
    return <>
        <Grid container spacing={2} style={{marginLeft: "10%", marginRight: "10%"}}>
            <Grid item xs={12} md={6} style={{display: "flex", flexDirection: 'column', justifyContent: "flex-start"}}>
                <div className={"line"}/>
                <h1>Who is BioRetis GmbH?</h1>
            </Grid>
            <Grid item xs={12} md={6} style={{flexDirection: 'column', alignSelf0: "flex-start"}}>
                <div className={"aboutContainer"}>
                    <p>
                        BioRetis GmbH is an interdisciplinary group with expertise in the fields of
                    </p>
                    <br/>
                    <ul className="custom-list" style={{paddingLeft: "5%"}}>
                        <li><i className="fas fa-check-circle list-icon"></i>
                            <p> Medicine </p></li>
                        <li><i className="fas fa-check-circle list-icon"></i> <p>Mathematics</p></li>
                        <li><i className="fas fa-check-circle list-icon"></i> <p>Bioinformatics</p></li>
                        <li><i className="fas fa-check-circle list-icon"></i><p> Biology</p></li>
                        <li><i className="fas fa-check-circle list-icon"></i><p>clinical trials, biobanks and
                            documentation.</p></li>
                    </ul>
                    <br/>
                    <p>Our research focuses are: </p>
                    <br/>
                    <p>the analysis of</p>
                    <br/>
                    <ul className="custom-list" style={{paddingLeft: "5%"}}>
                        <li><i className="fas fa-check-circle list-icon"></i><p>microarray gene expression data from
                            Affymetrix-based studies</p></li>
                        <li><i className="fas fa-check-circle list-icon"></i><p>high-dimensional cytometry data from
                            flow cytometric and mass spectrometric cell
                            investigations</p>
                        </li>
                        <li><i className="fas fa-check-circle list-icon"></i><p>microbiome sequence data from typing
                            sequencing</p></li>
                    </ul>
                    <br/>
                    <p>the development of</p>
                    <br/>
                    <ul className="custom-list" style={{paddingLeft: "5%"}}>
                        <li><i className="fas fa-check-circle list-icon"></i><p>software/databases/applications for the
                            collection of data in clinical trials</p></li>
                        <li><i className="fas fa-check-circle list-icon"></i><p>new algorithms for the exploitation of
                            functional networks</p></li>
                        <li><i className="fas fa-check-circle list-icon"></i><p>the management of biobanks</p></li>
                    </ul>
                </div>
            </Grid>
        </Grid>
    </>
}

export default AboutHero;